import { version } from "../package.json";

export default version;



// WEBPACK FOOTER //
// ./src/version.js